import dchAPI from '@/services/dchAPI';

const state = {
  timeseriesData: [],
  modes: [],
  reports: [],
};

const getters = {
  allTimeseriesData: (state) => state.timeseriesData,
  allModes: (state) => state.modes,
  allReports: (state) => state.reports,
};

const actions = {
  async fetchTimeseriesData({ commit }, urlPostfix) {
    await getData(urlPostfix, commit).then((data) => {
      commit('setTimeseriesData', data);
    });
  },
  async fetchModes({ commit }, urlPostfix) {
    await getModes(urlPostfix).then((modes) => {
      commit('setModes', modes);
    });
  },
  async fetchReports({ commit }, urlPostfix) {
    await getReports(urlPostfix).then((reports) => {
      commit('setReports', reports);
    });
  },
};

function getData(urlPostfix, cursor, data = []) {
  let cursorString = typeof cursor === 'string' ? `&cursor=${cursor}` : '';
  return dchAPI.get('timeseries' + urlPostfix + cursorString).then((response) => {
    let transformedData = response.data.data.map(
      (r) => (r = { ...r, asset_id: r.asset_id.toString() })
    );
    data.push(...transformedData);

    if (!response.data.meta.cursor) {
      return data;
    }

    return getData(urlPostfix, response.data.meta.cursor, data);
  });
}

function getModes(urlPostfix, cursor, data = []) {
  let cursorString = typeof cursor === 'string' ? `&cursor=${cursor}` : '';
  return dchAPI.get('voyages/modes' + urlPostfix + cursorString).then((response) => {
    let ports = {};
    const includedItems = response.data.included || [];
    for (let j = 0; j < includedItems.length; j++) {
      let includedItem = includedItems[j];
      if (includedItem.type == 'ports') {
        for (let i = 0; i < includedItem.data.length; i++) {
          let port = includedItem.data[i];
          ports[port.locode] = port;
        }
      }
    }

    let transformedData = (response.data.data || []).flatMap((r) =>
      r.modes.map((mode) => ({
        ...mode,
        asset_id: r.asset_id.toString(),
        asset_name: r.name,
        from_port_info: ports[mode.from_port],
        to_port_info: ports[mode.to_port],
      }))
    );
    data.push(...transformedData);

    if (!response.data.meta?.cursor) {
      return data;
    }
    return getModes(urlPostfix, response.data.meta.cursor, data);
  });
}

function getReports(urlPostfix) {
  return dchAPI.get('voyages/reports' + urlPostfix).then((response) => response.data.data || []);
}

const mutations = {
  setTimeseriesData: (state, timeseriesData) => {
    state.timeseriesData = timeseriesData;
  },
  setModes: (state, modes) => {
    state.modes = modes;
  },
  setReports: (state, reports) => {
    state.reports = reports;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
